import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QueuedComponent } from './queued/queued.component';
import { MyTasksComponent } from './my-tasks/my-tasks.component';
import { MyInvolvedComponent } from './my-involved/my-involved.component';
import { MyArchiveComponent } from './my-archive/my-archive.component';
import { ManageComponent } from './manage/manage.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { TreeWithTableComponent } from './tree-with-table/tree-with-table.component';
import { MatTableQueueComponent } from './queued/mat-table-queue/mat-table-queue.component';
import { MatSortModule } from '@angular/material/sort';
import { NodeModule } from '../node/node.module';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ReassignChangeNodeStateComponent } from './reassignchange-node/reassign-change-node-state/reassign-change-node-state.component';
import { ChangeNodeComponent } from './reassignchange-node/change-node/change-node.component';
const components = [QueuedComponent, MyTasksComponent, MyInvolvedComponent, MyArchiveComponent, ManageComponent, MatTableQueueComponent, TreeWithTableComponent,
  ReassignChangeNodeStateComponent, ChangeNodeComponent
];
@NgModule({  
  declarations: [components],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    MatSortModule,
    NodeModule,
    CommonComponentsModule,
    PipesModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WorkBenchModule {
  static forRoot(): ModuleWithProviders<WorkBenchModule> {
    return {
        ngModule: WorkBenchModule,
        providers: []
    }
 }
}
